// extracted by mini-css-extract-plugin
export var chip = "_50-0";
export var filterDropdown = "_50-5";
export var filterItem = "_50-6";
export var icon = "_50-1";
export var removeButton = "_50-3";
export var removeIcon = "_50-4";
export var separator = "_50-2";